<div class="app-shell" [attr.data-theme]="appTheme">
  <ng-container *ngIf="isLoggedIn$ | async as isLoggedIn; else loggedOutView">
    <app-navbar></app-navbar>

    <app-header [branchName]="UserBranchName" [userRole]="UserJobTitle"
        [environmentName]="environmentName + ' Environment'">
      </app-header>

      <div *ngIf="(isLoggedIn$ | async) === true" class="content-area">
        <app-main-layout>
          <router-outlet (activate)="onRouteActivation($event)"></router-outlet>
        </app-main-layout>
        <footer class="main-footer text-center py-3">
          <div class="text-muted text-small">
            &copy; {{ currentYear }} Copyright: Finbond Mutual Bank
          </div>
        </footer>
        <app-apiloader></app-apiloader>
      </div>
  </ng-container>

  <ng-template #loggedOutView>
    <router-outlet (activate)="onRouteActivation($event)" ></router-outlet>
  </ng-template>

  <lms-slide-panel [isOpen]="pVisible" [canUsePanel]="panelAvailable" [allowPinning]="true" [panelside]="'left'" [panelWidth]="'300px'">
  </lms-slide-panel>
</div>

